import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { InputType } from '../../../../../utils/@globalTypes';
import {
  KIDS_AGES_REQ,
  kidsAgeMask,
  priceMask,
  REQUIRED_FIELD_ERROR2,
} from '../../../../../utils/constants';
import Input from '../../../../../components/Input';

import styles from './KidsFeedingBlock.module.scss';
import Tooltip from '../../../../../components/Tooltip';
import {
  FeedingSettingsType,
  KidsFeegingType,
} from '../../../../../redux/types/mainObjectTypes';

type KidsFeedingType = {
  item: KidsFeegingType;
  index: number;
  error: any;
};

const KidsFeedingBlock = ({ item, index, error }: KidsFeedingType) => {
  const {
    setFieldValue,
    handleChange,
    values,
    setFieldTouched,
    validateField,
    touched,
    setFieldError,
    resetForm,
    errors,
  } = useFormikContext<FeedingSettingsType>();

  useEffect(() => {
    if (index === 0) {
      values.ageKidsFree
        ? setFieldValue(`kids[0].start_age`, values.ageKidsFree)
        : setFieldValue(`kids[0].start_age`, 0);
    }
  }, [values.ageKidsFree, index]);

  useEffect(() => {
    if (index > 0 && values?.kids[index - 1]?.end_age) {
      setFieldValue(
        `kids[${index}].start_age`,
        Number(values.kids[index - 1].end_age) + 1,
      );
    }
  }, [values.kids[index - 1]]);

  const touch = touched.kids && touched.kids[index];

  useEffect(() => {
    if (touch?.end_age) {
      validateField(`kids[${index}].end_age`);
    }
    if (touch?.kids_breakfast) {
      if (values.has_breakfast && !values.kids[index].kids_breakfast) {
        setFieldError(`kids[${index}].kids_breakfast`, REQUIRED_FIELD_ERROR2);
      } else setFieldError(`kids[${index}].kids_breakfast`, '');
    }
    if (touch?.kids_lunch) {
      if (values.has_lunch && !values.kids[index].kids_lunch) {
        setFieldError(`kids[${index}].kids_lunch`, REQUIRED_FIELD_ERROR2);
      } else setFieldError(`kids[${index}].kids_lunch`, '');
    }
    if (touch?.kids_dinner) {
      if (values.has_dinner && !values.kids[index].kids_dinner) {
        setFieldError(`kids[${index}].kids_dinner`, REQUIRED_FIELD_ERROR2);
      } else setFieldError(`kids[${index}].kids_dinner`, '');
    }
  }, [touched, values]);

  useEffect(() => {
    if (values.kids[index].start_age && values.kids[index].end_age) {
      validateField(`kids[${index}].end_age`);
    }
  }, [values]);

  useEffect(() => {
    if (!values.has_breakfast && values.kids[index].kids_breakfast) {
      setFieldValue(`kids.${index}.kids_breakfast`, '');
    }
    if (!values.has_lunch && values.kids[index].kids_lunch) {
      setFieldValue(`kids.${index}.kids_lunch`, '');
    }
    if (!values.has_dinner && values.kids[index].kids_dinner) {
      setFieldValue(`kids.${index}.kids_dinner`, '');
    }
  }, [values]);

  return (
    <div className={styles.container}>
      <div className={styles.ageLine}>
        <div className={styles.text}>
          дети
          <span className={styles.countAge}> {item.start_age} </span>-
        </div>
        <div className={styles.kidsAges}>
          <Input
            placeholder="Возраст"
            type={InputType.MASK}
            mask={kidsAgeMask}
            value={(item.end_age && item.end_age.toString()) || ''}
            onChange={handleChange(`kids[${index}].end_age`)}
            containerClassName={'kidsAge'}
            errText={error?.end_age && error.end_age}
            onBlur={() => setFieldTouched(`kids[${index}].end_age`)}
          />
        </div>
        <div className={styles.text}>лет включительно</div>
        <div className={styles.text}>
          <Tooltip requirementsText={KIDS_AGES_REQ} error={!!error?.end_age} />
        </div>
      </div>
      {values.has_breakfast && (
        <div className={styles.feedBlock}>
          <div className={styles.feedTitle}>Завтрак</div>
          <div className={styles.input}>
            <Input
              placeholder="Введите цену"
              type={InputType.MASK}
              mask={priceMask}
              value={item.kids_breakfast}
              onChange={handleChange(`kids.${index}.kids_breakfast`)}
              errText={error?.kids_breakfast && error.kids_breakfast}
              onBlur={() => setFieldTouched(`kids.${index}.kids_breakfast`)}
            />
          </div>
          <span className={styles.feedTitle}>BYN</span>
        </div>
      )}
      {values.has_lunch && (
        <div className={styles.feedBlock}>
          <div className={styles.feedTitle}>Обед</div>
          <div className={styles.input}>
            <Input
              placeholder="Введите цену"
              type={InputType.MASK}
              mask={priceMask}
              value={item.kids_lunch}
              onChange={handleChange(`kids.${index}.kids_lunch`)}
              errText={error?.kids_lunch && error.kids_lunch}
              onBlur={() => setFieldTouched(`kids.${index}.kids_lunch`)}
            />
          </div>
          <span className={styles.feedTitle}>BYN</span>
        </div>
      )}
      {values.has_dinner && (
        <div className={styles.feedBlock}>
          <div className={styles.feedTitle}>Ужин</div>
          <div className={styles.input}>
            <Input
              placeholder="Введите цену"
              type={InputType.MASK}
              mask={priceMask}
              value={item.kids_dinner}
              onChange={handleChange(`kids.${index}.kids_dinner`)}
              errText={error?.kids_dinner && error.kids_dinner}
              onBlur={() => setFieldTouched(`kids.${index}.kids_dinner`)}
            />
          </div>
          <span className={styles.feedTitle}>BYN</span>
        </div>
      )}
    </div>
  );
};

export default KidsFeedingBlock;
